import CrashDetectionMonitorPage from './CrashDetectionMonitorPage'

export default CrashDetectionMonitorPage
